import { Injectable, Output, EventEmitter } from "@angular/core";

@Injectable({
	providedIn: "root",
})
export class FilterService {
	@Output() filterChangeEvent: EventEmitter<any> = new EventEmitter();
	@Output() bundleFilterChangeEvent: EventEmitter<any> = new EventEmitter();
	@Output() searchClickedEvent: EventEmitter<boolean> = new EventEmitter();

	emit(filterObj: any) {
		this.filterChangeEvent.emit(filterObj);
	}

	search() {
		this.searchClickedEvent.emit(true);
	}
}
